module.exports = __webpack_public_path__ + "img/polkadot-circle.93d136cf.svg";